/**
 * 采集详情页数据增强器
 * 优先级：4
 * 职责：从 PinDetailContext 注入详情页数据
 */

import { DataEnricher, EnrichContext } from "./types";
import { PinDetailContext } from "../context/PinDetailContext";

export class PinDetailEnricher implements DataEnricher {
  name = "PinDetailEnricher";
  priority = 4;

  shouldEnrich(context: EnrichContext): boolean {
    const { page, options } = context;
    if (options?.enablePinDetail === false) return false;

    // 采集详情页需要详情页数据
    return page.page_nm === "采集详情页";
  }

  enrich(context: EnrichContext): Record<string, any> {
    const { trackData } = context;
    const pinDetailContext = PinDetailContext.get();

    if (pinDetailContext) {
      // 如果调用方已经传了数据，使用调用方的（最高优先级）
      // 否则使用上下文中的
      Object.assign(trackData, {
        pin_id: trackData.pin_id || pinDetailContext.pin_id,
        board_id: trackData.board_id || pinDetailContext.board_id,
        file_id: trackData.file_id || pinDetailContext.file_id,
        content_type: trackData.content_type || pinDetailContext.content_type,
        pin_source: trackData.pin_source || pinDetailContext.pin_source,
        // 合并扩展字段
        ...(pinDetailContext.ext || {}),
      });

      if (process.env.NODE_ENV === "development") {
        console.log("[PinDetailEnricher] Injected pin detail context:", {
          pin_id: trackData.pin_id,
          board_id: trackData.board_id,
        });
      }
    }

    return trackData;
  }
}
